import React from 'react';
import QuoteItem from './QuoteItem';
import { useSelector } from 'react-redux';
import styles from './Quotes.module.css';
import Spinner from '../components/UI/Spinner';
import { Link } from 'react-router-dom';
import { useNavigate, useLocation } from 'react-router-dom';

const sortQuotes = (quotes, ascending) => {
  return quotes.sort((quoteA, quoteB) => {
    if (ascending) {
      return quoteA.id > quoteB.id ? 1 : -1;
    } else {
      return quoteA.id < quoteB.id ? 1 : -1;
    }
  });
};

const Quotes = () => {
  
  const quotes = useSelector(state => state.quote.quotes);
  const notificationStatus = useSelector(state => state.notification.status);
  const navigate = useNavigate();
  const location = useLocation();
  
  const queryParams = new URLSearchParams(location.search);

    const isSortingAscending = queryParams.get('sort') === 'asc';

    const sortedQuotes = sortQuotes([...quotes], isSortingAscending)

    const changeSortingHandler = () => {
      navigate('?sort=' + (!isSortingAscending ? 'asc' : 'desc'));
    }

    let content = sortedQuotes.map(quote => <QuoteItem id={quote.id} key={quote.id} text={quote.text} author={quote.author} />)

    if(sortedQuotes.length === 0) {
      content = <p className={styles.paragraph}>There are no quotes to display. But hey, you can <Link to="/new-quote">create new quote!</Link></p>
    }

    if(notificationStatus === "loading") {
      content = <Spinner />
    }

  return (
    <div className={styles.quotes}>
        <button onClick={changeSortingHandler} className={styles.sorting}>Sort {isSortingAscending ? "Descending" : "Ascending"}</button>
        {content}
    </div>
  )
}

export default Quotes